import { render, staticRenderFns } from "./bindingRelationship.vue?vue&type=template&id=6306694d&scoped=true&"
import script from "./bindingRelationship.vue?vue&type=script&lang=js&"
export * from "./bindingRelationship.vue?vue&type=script&lang=js&"
import style0 from "./bindingRelationship.vue?vue&type=style&index=0&id=6306694d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306694d",
  null
  
)

export default component.exports